// extracted by mini-css-extract-plugin
export default {"custom-range-input":"ClipAudioPlayer_custom-range-input__Qd2AQ"};